import { NgModule } from '@angular/core';
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';
import { LogoComponent } from './logo/logo.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from './loading/loading.component';
import { SelectComponent } from './select/select.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { PaginationComponent } from './pagination/pagination.component';
import { TextareaComponent } from './textarea/textarea.component';
import { PmsErrorComponent } from './pms-error/pms-error.component';
import { TranslateModule } from '@ngx-translate/core';
import { EnlargeImageModalComponent } from './enlarge-image-modal/enlarge-image-modal.component';
import { ImageComponent } from './image/image.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DragModalDirective } from './directives/drag-modal.directive';
import { PPANoBoxComponent } from './ppa-no-box/ppa-no-box.component';
import { StatusColorDirective } from './directives/status-color.directive';
import { RemarkGroupComponent } from './remark-group/remark-group.component';
import { StringCheckPipe } from './pipe/string-check.pipe';
import { NRCBoxComponent } from './nrc-box/nrc-box.component';
import { ComboBoxComponent } from './combo-box/combo-box.component';
import { TimeRangePickerComponent } from './time-range-picker/time-range-picker.component';
import { AppNumericInputComponent } from './numeric-input/numeric-input.component';

@NgModule({
  declarations: [
    ButtonComponent,
    InputComponent,
    LogoComponent,
    LoadingComponent,
    SelectComponent,
    RadioGroupComponent,
    PaginationComponent,
    TextareaComponent,
    PmsErrorComponent,
    EnlargeImageModalComponent,
    ImageComponent,
    DragModalDirective,
    StatusColorDirective,
    PPANoBoxComponent,
    RemarkGroupComponent,
    StringCheckPipe,
    NRCBoxComponent,
    ComboBoxComponent,
    TimeRangePickerComponent,
    AppNumericInputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    ButtonComponent,
    InputComponent,
    LogoComponent,
    LoadingComponent,
    SelectComponent,
    RadioGroupComponent,
    PaginationComponent,
    TextareaComponent,
    PmsErrorComponent,
    EnlargeImageModalComponent,
    ImageComponent,
    NgxSkeletonLoaderModule,
    TranslateModule,
    PPANoBoxComponent,
    StatusColorDirective,
    RemarkGroupComponent,
    StringCheckPipe,
    NRCBoxComponent,
    ComboBoxComponent,
    TimeRangePickerComponent,
    AppNumericInputComponent
  ],
})
export class SharedModule {}
